module.exports = __webpack_public_path__ + "static/img/150_TO8_1865_og.7215afe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/150_TO8_1865_og.jpg
// module id = /cxF
// module chunks = 0